/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim1DiagLeftIcon16Light = forwardRef('ArrowDim1DiagLeftIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M2 7a.5.5 0 0 0 1 0V3.707L12.293 13H9a.5.5 0 0 0 0 1h4a1 1 0 0 0 1-1V9a.5.5 0 0 0-1 0v3.293L3.707 3H7a.5.5 0 0 0 0-1H3a1 1 0 0 0-1 1v4Z" })));
});
